import { useMemo } from "react";
import { useSelector } from "react-redux";
import useAuthority from "utils/hooks/useAuthority";
import useResponsive from "utils/hooks/useResponsive";
import {
  highRoles,
  recyclerRoles,
} from "constants/moduleConstants/role.constant";

/**
 * True when the user is an end-customer (Customer only, no staff/recycler roles)
 * on a viewport below the `md` breakpoint — show mobile app shell.
 */
function useCustomerMobileShell() {
  const userAuthority = useSelector((state) => state.auth.user?.authority ?? []);
  const { smaller } = useResponsive();

  const isCustomer = useAuthority(userAuthority, ["Customer"]);
  const hasStaffOrRecyclerRole = useAuthority(userAuthority, [
    ...highRoles,
    ...recyclerRoles,
  ]);

  return useMemo(
    () => Boolean(isCustomer && !hasStaffOrRecyclerRole && smaller.md),
    [isCustomer, hasStaffOrRecyclerRole, smaller.md]
  );
}

export default useCustomerMobileShell;
